const COMPOSER_SKILL_TOKEN = /^\$[a-zA-Z][a-zA-Z0-9:_-]*$/;

/** Separate leading skill chips from request text without losing explicit invocations. */
export function splitLeadingComposerSkillLines(text: string): {
  readonly skillNames: string[];
  readonly body: string[];
} {
  const lines = text.split("\n");
  const skillNames: string[] = [];
  let start = 0;
  while (start < lines.length) {
    const trimmed = lines[start]!.trim();
    if (COMPOSER_SKILL_TOKEN.test(trimmed)) {
      skillNames.push(trimmed.slice(1));
    } else if (trimmed.length > 0) {
      break;
    }
    start += 1;
  }
  return { skillNames, body: lines.slice(start) };
}

/** Skip leading `$skill` tokens / blank lines so arranged prompts round-trip. */
export function skipLeadingComposerSkillLines(text: string): string[] {
  return splitLeadingComposerSkillLines(text).body;
}

/** Prefix an arranged prompt with one or more composer skill chip tokens. */
export function withComposerSkillTokens(
  skillNames: ReadonlyArray<string>,
  body: ReadonlyArray<string>,
): string {
  return [...skillNames.map((name) => `$${name}`), "", ...body].join("\n");
}

/** Prefix an arranged prompt with a composer skill chip token. */
export function withComposerSkillToken(skillName: string, body: ReadonlyArray<string>): string {
  return withComposerSkillTokens([skillName], body);
}
